/**
 * Section: Newsletter Modal
 * ------------------------------------------------------------------------------
 * Newsletter modal configuration for complete theme support
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace newsletterModal
 */

import log from 'salvo-lite/log'

import {register} from '@shopify/theme-sections'

import cssClasses from '../helpers/cssClasses'
import {on, getSiblings} from '../helpers/utils'

class MenuDrawer {
    constructor () {
        this._selectors = {
            drawerToggle: '[js-toggle="menuDrawerToggle"]',
            childMenuToggle: '[js-menu-drawer="childMenuToggle"]',
            grandChildMenuToggle: '[js-menu-drawer="grandChildMenuToggle"]',
            greatGrandChildMenuToggle: '[js-menu-drawer="greatGrandChildMenuToggle"]'
        }

        /**
         * Component selectors.
         */
        this._menus = [
            ...document.querySelectorAll(this._selectors.childMenuToggle),
            ...document.querySelectorAll(this._selectors.grandChildMenuToggle),
            ...document.querySelectorAll(this._selectors.greatGrandChildMenuToggle)
        ]

        /**
         * Component selectors.
         */
        this._nodeSelectors = {
            drawerToggle: document.querySelector(this._selectors.drawerToggle)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit (theme, section) {
        register('menu-drawer', {
            /**
             * Initiate toggle events on all sub-menus.
             */
            constructAccordionMenus () {
                const menusArray = [...this.section._menus]
                menusArray.forEach((element) => {
                    on('click', element, (event) => this.onItemClick(event, element))
                })
            },

            /**
             * Handle toggle event on menu item click.
             * @param {Event} event - Click event.
             * @param {HTMLElement} element - The menu item.
             */
            onItemClick (event, element) {
                event.preventDefault()
                this.toggleElement(element)
                this.toggleElement(getSiblings(element)[0])
            },

            /**
             * Check if item is active.
             * @param {HTMLElement} element - The menu item.
             */
            isItemActive (element) {
                return element.classList.contains(cssClasses.active)
            },

            /**
             * Toggle button state.
             * @param {HTMLElement} element - The toggled button.
             */
            toggleElement (element) {
                if (this.isItemActive(element)) {
                    this.showMenu(element)
                    return
                }
                this.hideMenu(element)
            },

            /**
             * Show menu.
             * @param {HTMLElement} element - The item to show.
             */
            showMenu (element) {
                element.classList.remove(cssClasses.active)
            },

            /**
             * Hide menu.
             * @param {HTMLElement} element - The item to hide.
             */
            hideMenu (element) {
                element.classList.add(cssClasses.active)
            },

            /**
             * Initialise section.
             */
            init () {
                this.section = theme.getSectionsByType('menu-drawer')
                this.MenuDrawer = theme.getComponentsById('menu-drawer-toggle')
                this.setEventListeners()
                this.constructAccordionMenus()
            },

            /**
             * Set click events on toggle selectors.
             */
            setEventListeners () {
                const toggle = this.section._nodeSelectors.drawerToggle

                on('click', toggle, () => {
                    if (toggle.classList.contains(cssClasses.active)) {
                        window.Frame.EventBus.emit('SiteHeader:update', 'drawer')
                        return
                    }

                    window.Frame.EventBus.emit('SiteHeader:update')
                })
            },

            /**
             * Event callback for Theme Editor `section:select` event
             */
            onSelect () {
                this.MenuDrawer.open()
            },

            /**
             * Event callback for Theme Editor 'shopify:section:deselect' event.
             */
            onDeselect () {
                this.MenuDrawer.close()
            },

            /**
             * Event callback for Theme Editor `section:load` event
             */
            onLoad () {
                this.init()
            }
        })
    }
}

export default MenuDrawer



// WEBPACK FOOTER //
// ./src/resources/scripts/sections/MenuDrawer.js